import TabInTabLayoutDiv from '../4layout/adminDashboard/TabInTabLayoutDiv'
import DataExportSideMenu from '../3modules/DataExport/DataExportSideMenu'
import DataExportTabs from '../3modules/DataExport/DataExportTabs'
import {useState} from 'react'
import { AuthorizationError } from '../1elements'
import {
    isAllowedToPerformFeature,
    isAllowedToViewAdminAccess
} from '../../services/permissions/permissionHelper'

const exportTabs = [
    {
        label: 'Master Data',
        description: '',
        value: 0,
        permission: 'export.master'
    },
    {
        label: 'Business Data',
        description: '',
        value: 1,
        permission: 'export.business',
        hidden: true
    }
]

const DataExportsTemplate = () => {
    const isAdmin = isAllowedToViewAdminAccess()
    const menuItems = exportTabs.filter(
        ({ permission, hidden }) => !hidden && (
            isAdmin || isAllowedToPerformFeature(permission)
        )
    )
    const [selectedTabIndex, setSelectedTabIndex] = useState(
        () => menuItems[0]?.value
    )

    if (menuItems.length === 0) {
        return <AuthorizationError />
    }

    return (
        <TabInTabLayoutDiv tabTitle={'Data Export'}>
            <DataExportSideMenu
                selectedTabIndex={selectedTabIndex}
                setSelectedTabIndex={setSelectedTabIndex}
                menuItems={menuItems}
            />
            <DataExportTabs
                selectedTabIndex={selectedTabIndex}
                allowedTabIndexes={menuItems.map(({ value }) => value)}
            />
        </TabInTabLayoutDiv>
    )
}

export default DataExportsTemplate
